import { BreakpointState, Breakpoints } from '@angular/cdk/layout';

export type BreakpointsType = keyof typeof Breakpoints;
export type BreakpointQuery = (typeof Breakpoints)[BreakpointsType] | string;

export class BreakpointMatch {
  private readonly _matches: string[] = [];

  constructor(private readonly _state: BreakpointState) {
    for (const [breakpointType, isActive] of Object.entries(
      _state.breakpoints,
    )) {
      if (isActive === true) {
        this._matches.push(...this._normalize(breakpointType));
      }
    }
  }

  public contains(breakpointQuery: BreakpointQuery): boolean {
    if (!this._matches.length) return false;

    if (this._isBreakpointIncluded(breakpointQuery)) {
      return true;
    }

    const normalized = this._normalize(breakpointQuery);
    if (!normalized.length) return false;

    const normalizedQuerySet = new Set(normalized);

    return this._matches.some((match) => normalizedQuerySet.has(match));
  }

  private _isBreakpointIncluded(breakpointQuery: BreakpointQuery): boolean {
    return (
      typeof breakpointQuery === 'string' &&
      this._matches.includes(breakpointQuery)
    );
  }

  private _normalize(value: string | string[]): string[] {
    const list = Array.isArray(value) ? value : [value];

    const rawItems = this._splitAndClean(list);
    const resolvedItems = rawItems.map((item) => this._resolveBreakpoint(item));

    return this._splitAndClean(resolvedItems);
  }

  private _splitAndClean(value: string | string[]): string[] {
    const list = Array.isArray(value) ? value : [value];

    return list
      .flatMap((item) => item.split(','))
      .map((item) => item.trim())
      .filter(Boolean);
  }

  private _resolveBreakpoint(item: string): string {
    const byKey = (Breakpoints as Record<string, string>)[item];
    return byKey ?? item;
  }
}
